import { Inject, Injectable } from "@angular/core";
import { CrudService } from "../crud.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { DOCUMENT } from "@angular/common";
import { ToastrService } from "ngx-toastr";

@Injectable({
    providedIn: "root",
})
export class UsersService extends CrudService {
    constructor(
        httpClient: HttpClient,
        @Inject(DOCUMENT) private document: Document,
        private toastr: ToastrService,
    ) {
        super(httpClient, "patient");
        this.endpoint = environment.endpoint + "patient";
    }

    getPatient(params?: any): Observable<boolean> {
        const t = this;

        return this.httpClient
            .get(t.endpoint, { headers: {}, params })
            .pipe(map((res: any) => res || []));
    }

    getAppointemntsTickets(params?: any): Observable<boolean> {
        const t = this;

        return this.httpClient
            .get(t.endpoint + "/appointments/tickets", { headers: {}, params })
            .pipe(map((res: any) => res || []));
    }

    getMyAppointmentsSlots(params?: any): Observable<boolean> {
        const t = this;

        return this.httpClient
            .get(environment.endpoint + "appointments/my-appointments/slots", {
                headers: {},
                params,
            })
            .pipe(map((res: any) => res || []));
    }

    getMyPrescription(params?: any): Observable<boolean> {
        const t = this;

        return this.httpClient
            .get(t.endpoint + "/my-prescriptions", { headers: {}, params })
            .pipe(map((res: any) => res || []));
    }

    getMyResults(params?: any): Observable<any> {
        const t = this;

        return this.httpClient
            .get(environment.endpoint + "results/my-results", {
                headers: {},
                params,
            })
            .pipe(map((res: any) => res || []));
    }

    postAppointment(params?: any): Observable<boolean> {
        const t = this;

        return this.httpClient
            .post(
                environment.endpoint + "appointments/make-appointments",

                params,
            )
            .pipe(map((res: any) => res || []));
    }

    getMyDocuments(): Observable<any[]> {
        return this.httpClient.get<any[]>(
            environment.endpoint + `documents/my-documents`,
        );
    }

    download(document: any) {
        const t = this;
        const headers = new HttpHeaders().set(
            "Authorization",
            "Bearer " + localStorage.getItem("token"),
        );

        this.httpClient
            .get(
                environment.endpoint +
                    "documents/download/" +
                    document.downloadReference,
                {
                    headers,
                    responseType: "blob" as "json",
                },
            )
            .subscribe({
                next: (response: any) => {
                    // Succes
                    const dataType = response.type;
                    const binaryData = [];
                    binaryData.push(response);
                    const downloadLink = t.document.createElement("a");
                    downloadLink.href = window.URL.createObjectURL(
                        new Blob(binaryData, { type: dataType }),
                    );
                    const filename =
                        document.name + "." + document.fileExtension;
                    if (filename) {
                        downloadLink.setAttribute("download", filename);
                    }
                    t.document.body.appendChild(downloadLink);
                    downloadLink.click();
                    downloadLink.remove();
                    window.URL.revokeObjectURL(downloadLink.href);

                    // Toast succes + complete
                    this.toastr.success(
                        `"${filename}" descărcat cu succes!`,
                        "Gata!",
                        {
                            timeOut: 3000,
                            progressBar: true,
                        },
                    );
                },
                error: (error) => {
                    // Toast eroare
                    console.error("Download error:", error);
                    this.toastr.error(
                        error.status === 401
                            ? "Token expirat. Re-autentificare necesară."
                            : error.status === 404
                              ? "Documentul nu a fost găsit."
                              : "Eroare la descărcare. Încearcă din nou.",
                        "Eroare descărcare",
                        {
                            timeOut: 5000,
                            progressBar: true,
                        },
                    );
                },
            });
    }

    donwloadResult(downloadReference: any, downloadReferenceName: any) {
        const t = this;
        const headers = new HttpHeaders().set(
            "Authorization",
            "Bearer " + localStorage.getItem("token"),
        );
        this.httpClient
            .get(t.endpoint + "/download/" + downloadReference, {
                headers,
                responseType: "blob" as "json",
            })
            .subscribe((response: any) => {
                const dataType = response.type;
                const binaryData = [];
                binaryData.push(response);
                const downloadLink = t.document.createElement("a");
                downloadLink.href = window.URL.createObjectURL(
                    new Blob(binaryData, { type: dataType }),
                );
                const filename = downloadReferenceName;
                if (filename) {
                    downloadLink.setAttribute("download", filename);
                }
                t.document.body.appendChild(downloadLink);
                downloadLink.click();
            });
    }

    updatePassword(data: any): Observable<boolean> {
        const t = this;
        return this.httpClient
            .put(t.endpoint + "/password", data, { headers: {} })
            .pipe(map((res: any) => res || []));
    }

    updateDetails(data: any): Observable<boolean> {
        const t = this;
        return this.httpClient
            .put(t.endpoint, data, { headers: {} })
            .pipe(map((res: any) => res || []));
    }

    updateGdpr(data: any): Observable<boolean> {
        const t = this;
        return this.httpClient
            .put(t.endpoint + "/gdpr", data, { headers: {} })
            .pipe(map((res: any) => res || []));
    }

    getHealthOrganizations(params?: any): Observable<boolean> {
        const t = this;

        return this.httpClient
            .get(environment.endpoint + "health-organisations", {
                headers: {},
                params,
            })
            .pipe(map((res: any) => res || []));
    }

    postTicket(credentials: any): Observable<any> {
        return this.httpClient
            .post(
                environment.endpoint + "tickets/external-tickets",
                credentials,
            )
            .pipe(
                map((data: any) => {
                    return data;
                }),
            );
    }

    postExternalTicketWithFile(formData: FormData): Observable<any> {
        return this.httpClient.post(
            environment.endpoint + "tickets/external-tickets/file", // endpoint-ul tău Spring Boot
            formData,
            // ⚠️ NU seta Content-Type manual!
            // Angular setează automat 'multipart/form-data' cu boundary
        );
    }

    shareResult(uuid: string): any {
        return this.httpClient.post(
            environment.endpoint + `results/my-results/${uuid}/share`,
            {},
        );
    }

    downloadResult(downloadReference: string): Observable<any> {
        return this.httpClient.get(
            environment.endpoint + `results/download/${downloadReference}`,
            {
                responseType: "blob" as "json",
            },
        );
    }

    readResult(uuid: string): Observable<any> {
        return this.httpClient.get(
            environment.endpoint + `results/my-results/${uuid}/read`,
        );
    }
    // În users.service.ts - adaugă aceste funcții

    getMyAppointments(): Observable<any[]> {
        return this.httpClient.get<any[]>(
            environment.endpoint + "appointments/my-appointments",
        );
    }

    getTopResults(limit = 3): Observable<any[]> {
        return this.httpClient.get<any[]>(
            environment.endpoint + `results/my-results/top?limit=${limit}`,
        );
    }

    getMyTicketsTop(limit = 3): Observable<any[]> {
        return this.httpClient.get<any[]>(
            environment.endpoint + `tickets/my-tickets/top?limit=${limit}`,
        );
    }

    getMyExternalTicketsTop(limit = 3): Observable<any[]> {
        return this.httpClient.get<any[]>(
            environment.endpoint +
                `tickets/my-external-tickets/top?limit=${limit}`,
        );
    }
    getMyDocumentsTop(limit = 3): Observable<any[]> {
        return this.httpClient.get<any[]>(
            environment.endpoint + `documents/my-documents/top?limit=${limit}`,
        );
    }

    // users.service.ts sau notifications.service.ts
    getNotifications(): Observable<any[]> {
        return this.httpClient.get<any[]>(
            environment.endpoint + "notifications",
        );
    }

    getUnreadCount(): Observable<number> {
        return this.httpClient.get<number>(
            environment.endpoint + "notifications/unread-count",
        );
    }

    markNotificationAsRead(id: number): Observable<void> {
        return this.httpClient.put<void>(
            environment.endpoint + `notifications/${id}/read`,
            {}, // body gol, dar necesar pentru PUT[web:134]
        );
    }

    markAllNotificationsAsRead(): Observable<{ markedAsRead: number }> {
        return this.httpClient.put<{ markedAsRead: number }>(
            environment.endpoint + "notifications/read-all",
            {},
        );
    }

    getDocumentTypes(): Observable<any[]> {
        return this.httpClient.get<any[]>(
            environment.endpoint + "documents/my-documents/document-types",
        );
    }

    getInsuranceCompanies(): Observable<any[]> {
        return this.httpClient.get<any[]>(
            environment.endpoint +
                "appointments/my-appointments/insurance-companies",
        );
    }

    cancelAppointment(data: {
        eventId: string;
        scheduleId: string;
    }): Observable<any> {
        return this.httpClient.post(
            environment.endpoint + "appointments/my-appointments/cancel",
            data,
        );
    }

    getMyTickets(): Observable<any[]> {
        return this.httpClient.get<any[]>(
            environment.endpoint + "tickets/my-tickets",
        );
    }

    getExternalTickets(): Observable<any[]> {
        return this.httpClient.get<any[]>(
            environment.endpoint + "tickets/external-tickets",
        );
    }
    uploadDocument(documentTypeCode: string, fileName: string, file: File) {
        const formData = new FormData();
        formData.append("documentTypeCode", documentTypeCode);
        formData.append("fileName", fileName);
        formData.append("file", file, fileName);

        return this.httpClient.post(
            environment.endpoint + "documents/upload",
            formData,
        );
    }
    // users.service.ts
    getSharedResult(token: string) {
        return this.httpClient.get(
            environment.endpoint + `results/shared-results/${token}`,
        );
    }
}
